import './assets/main.css'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import axios from 'axios'
// @ts-ignore: 忽略vuex模块的类型检查
import { createStore } from 'vuex'
// @ts-ignore: 忽略store.js的类型检查
import store from './stores/store.js'

const app = createApp(App)
const pinia = createPinia()

// 注册所有Element Plus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 配置axios
axios.defaults.baseURL = '/api'
app.config.globalProperties.$axios = axios

// 处理页面刷新时的路由恢复
window.addEventListener('beforeunload', () => {
  // 保存当前路由信息到localStorage
  localStorage.setItem(
    'currentRoute',
    JSON.stringify({
      path: router.currentRoute.value.path,
      query: router.currentRoute.value.query,
      params: router.currentRoute.value.params,
    }),
  )

  // 保存Vuex状态到localStorage
  localStorage.setItem('vuexState', JSON.stringify(store.state))
})

// 页面加载时恢复路由和状态
const savedState = localStorage.getItem('vuexState')
if (savedState) {
  try {
    const state = JSON.parse(savedState)
    // 恢复Vuex状态
    Object.keys(state).forEach((key) => {
      // @ts-ignore: 忽略动态属性赋值的类型检查
      store.state[key] = state[key]
    })
  } catch (e) {
    console.error('恢复Vuex状态失败:', e)
  }
}

// 恢复路由
const savedRoute = localStorage.getItem('currentRoute')
if (savedRoute) {
  try {
    const route = JSON.parse(savedRoute)
    // 等待DOM加载完成后再进行路由跳转
    window.addEventListener('DOMContentLoaded', () => {
      // 如果当前不在保存的路由上，则导航到保存的路由
      const currentPath = window.location.hash.slice(1).split('?')[0]
      if (currentPath !== route.path) {
        router
          .push({
            path: route.path,
            query: route.query,
            params: route.params,
          })
          .catch((err) => {
            console.error('路由恢复失败:', err)
          })
      }
    })
  } catch (e) {
    console.error('恢复路由失败:', e)
  }
}

app.use(router)
app.use(pinia)
app.use(ElementPlus, { locale: zhCn })
app.use(store)

app.mount('#app')
